import type { FeatureStyleNode } from '../feature-style.model';

export interface PeriodParams {
  of: string;
}

export const PERIOD_DEFAULT_PARAMS: Omit<PeriodParams, 'of'> = {};

export const PERIOD_DEFAULTS: FeatureStyleNode = {
  line: { color: 'indigo', strokeWidth: 2, dash: 0 },
  subparts: {
    arrow: { line: { dash: 0 } },
    leftTrace: { line: { dash: 3 } },
    rightTrace: { line: { dash: 3 } },
  },
};
